'use client';

import React, { useState, useEffect } from 'react';
import './style.css';
import { Icon360View, IconArrowAutofitContent, IconEyeDotted, IconTargetArrow } from '@tabler/icons-react';
import { RootState } from 'src/redux/store';
import { useSelector } from 'react-redux';

const Dashboard2 = () => {
  const user = useSelector((state: RootState) => state.user.employeeDetails);
  const username = user?.FM03_EmployeeName || 'Vstar_User';

  const fullText = `${username}!`; // Fixed: "Welcome", not "Wllome"
  const [displayedText, setDisplayedText] = useState('');
  const [isTypingDone, setIsTypingDone] = useState(false);

  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      if (index < fullText.length) {
        setDisplayedText(fullText.slice(0, index + 1)); // Use slice to avoid char-by-char mutation issues
        index++;
      } else {
        setIsTypingDone(true);
        clearInterval(timer);
      }
    }, 80);

    return () => clearInterval(timer);
  }, [fullText]); // Re-run if username changes

  return (
    <div className="w-full flex flex-col gap-6 p-4 md:p-6 max-w-7xl mx-auto">

      {/* Welcome with Typing Effect */}
      <div className="bg-gradient-to-r from-vstarPrimary-900 to-black text-white rounded-xl shadow-lg p-8 text-center">
        <h1 className="text-3xl md:text-4xl font-bold mb-2 min-h-[3rem] flex items-center justify-center">
          <span>
          <span className='font-light'> Welcome back,</span> {displayedText}
            {/* Blinking cursor */}
            {!isTypingDone && (
              <span className="inline-block w-1 h-9 bg-white ml-1 animate-pulse align-middle" />
            )}
          </span>
        </h1>

        <p className="text-lg opacity-90 mt-3">
          We're glad to have you here. Let's make today productive.
        </p>
      </div>

      {/* Vision & Mission */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        <div className="bg-white dark:bg-black/30  rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-xl transition-shadow">
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-vstarPrimary-900 to-red-900   rounded-full flex items-center justify-center text-white font-bold text-xl">
              <IconEyeDotted size={28} />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 dark:text-vstargray-100 ml-3">Our Vision</h2>
          </div>
          <p className="text-gray-600 dark:text-gray-400  leading-relaxed">
            To emerge as a trendsetting and youthful brand of lifestyle products, providing delight consistently to customers across the globe.
          </p>
        </div>

        <div className="bg-white dark:bg-black/30   rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-xl transition-shadow">
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-vstarPrimary-900 to-red-900 rounded-full flex items-center justify-center text-white font-bold text-xl">
              <IconTargetArrow size={24} />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 ml-3 dark:text-vstargray-100">Our Mission</h2>
          </div>
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
            To create a unique style that encompasses the trends of the world market .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard2;